import type * as Types from '../../graphql/types.d'

import type { DocumentNode } from 'graphql'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
export type GeocodeAddressQueryVariables = Types.Exact<{
	query: Types.Scalars['String']['input']
}>

export type GeocodeAddressQuery = {
	__typename?: 'Query'
	geocodeAddress: {
		__typename: 'GeoPoint'
		id: string
		name?: string | null
		address?: string | null
		city?: string | null
		state?: string | null
		country?: string | null
		countryCode?: string | null
		latitude: number
		longitude: number
		isOsm?: boolean | null
	}
}

export type AutocompleteByNameQueryVariables = Types.Exact<{
	query: Types.Scalars['String']['input']
}>

export type AutocompleteByNameQuery = {
	__typename?: 'Query'
	autocompleteByName: Array<{
		__typename: 'GeoPoint'
		id: string
		name?: string | null
		address?: string | null
		city?: string | null
		state?: string | null
		country?: string | null
		countryCode?: string | null
		latitude: number
		longitude: number
		isOsm?: boolean | null
	}>
}

export type SearchGeoPlaceByNameQueryVariables = Types.Exact<{
	query: Types.SearchGooglePlacesInput
}>

export type SearchGeoPlaceByNameQuery = {
	__typename?: 'Query'
	searchGeoPlaceByName: Array<{
		__typename: 'GeoPoint'
		id: string
		name?: string | null
		address?: string | null
		city?: string | null
		state?: string | null
		country?: string | null
		countryCode?: string | null
		latitude: number
		longitude: number
		isOsm?: boolean | null
	}>
}

export const GeocodeAddressDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'GeocodeAddress' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'geocodeAddress' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'query' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'GeoPointFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'GeoPointFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GeoPoint' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'name' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'address' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'city' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'state' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'country' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isOsm' } },
				],
			},
		},
	],
} as unknown as DocumentNode
export const AutocompleteByNameDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'AutocompleteByName' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'autocompleteByName' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'query' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'GeoPointFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'GeoPointFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GeoPoint' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'name' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'address' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'city' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'state' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'country' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isOsm' } },
				],
			},
		},
	],
} as unknown as DocumentNode
export const SearchGeoPlaceByNameDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'SearchGeoPlaceByName' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchGooglePlacesInput' } },
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'searchGeoPlaceByName' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'query' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'GeoPointFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'GeoPointFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GeoPoint' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'name' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'address' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'city' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'state' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'country' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isOsm' } },
				],
			},
		},
	],
} as unknown as DocumentNode
